import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import Icon from '../ui/Icon';
import { BOTTOM_TABS, activeTab } from './navConfig';
import './shell.css';

export default function BottomNav() {
  const history = useHistory();
  const location = useLocation();
  const active = activeTab(location.pathname);

  return (
    <nav className="hive-bottomnav" aria-label="Primary">
      {BOTTOM_TABS.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            className={`hive-bottomnav-item hive-tap${isActive ? ' is-active' : ''}`}
            onClick={() => history.push(tab.path)}
            aria-current={isActive ? 'page' : undefined}
          >
            <Icon name={tab.icon} size={22} strokeWidth={isActive ? 2.4 : 2} />
            <span className="hive-bottomnav-label">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
